import { render, staticRenderFns } from "./QrcodeReader.vue?vue&type=template&id=fda42224"
import script from "./QrcodeReader.vue?vue&type=script&lang=ts"
export * from "./QrcodeReader.vue?vue&type=script&lang=ts"
import style0 from "./QrcodeReader.vue?vue&type=style&index=0&id=fda42224&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports